<template>
  <div class="parent">
    <div class="headSty">
      <spot :title="'管控记录'"></spot>
    </div>
    <div class="listSty" v-if="switchLog.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        :offset="2"
        @load="onLoad"
      >
        <div class="cellSty" v-for="(log, index) in switchLog" :key="index">
          <div class="content">
            <div>{{ log.when }}</div>
            <div class="rowSty">
              <div>
                <span>{{ log.who }}</span
                ><span class="colSty">{{log.source || ''}} </span>
              </div>
              <div>{{ log.do }}{{log.item}}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <Empty :word="'暂无信息'" v-else></Empty>
  </div>
</template>

<script>
import spot from "./components/spot.vue";
import { entertainmentswitchlog } from "@/api/squirrelCup";
import { List, Cell } from "vant";
import Empty from "./components/Empty.vue";

export default {
  data() {
    return {
      switchLog: [],
     page: {
        pageIndex: 0,
        pageSize: 10,
      },
      total: '',
      loading: false,
      finished: false,
    };
  },
  components: {
    spot,
    [List.name]: List,
    [Cell.name]: Cell,
    Empty,
  },
  mounted() {
    this.onLoad();
    document.title ="娱乐管控"
  },
  methods: {
    getSwitchlog() {
      let account_id = JSON.parse(localStorage.getItem("headInfo")).accountId;
   let parmDta = {
        ...this.page,
        param: {
          account_id: Number(account_id), // 账号Id
        },
      };
      entertainmentswitchlog(parmDta).then((res) => {
        this.total = res.data.count;
        this.switchLog = this.switchLog.concat(res.data.log);

        this.loading = false;
        if (this.switchLog.length >= this.total)
          return (this.finished = true);
      });
    },
    onLoad() {
      this.page.pageIndex++;
      this.getSwitchlog();
    },
  },
};
</script>
<style scoped lang="less">
.parent {
  .headSty {
    margin: 48px;
  }
  .listSty {
    height: calc(100vh - 190px);
    overflow: auto;
  }
  .cellSty {
    margin: 0 16px;

    border-bottom: 2px solid rgba(88, 171, 246, 0.2);
    .content {
      padding: 32px 32px 34px 32px;
      font-size: 24px;
      color: #999999;
    }
    .rowSty {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      font-size: 28px;
      color: #323232;
      .colSty {
        font-size: 28px;
        color: #58abf6;

        margin-left: 16px;
      }
    }
  }
}
</style>
